(() => {
  if (customElements.get('ol-pallet-mix')) return;
  class PalletMix extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.inputs = [...this.querySelectorAll('[data-mix-size]')];
      this.quantity = this.querySelector('[data-pallet-quantity]');
      this.button = this.querySelector('[data-pallet-submit]');
      this.status = this.querySelector('[data-mix-status]');
      this.form.addEventListener('input', () => this.update());
      this.querySelectorAll('[data-full-size]').forEach(button => button.addEventListener('click', () => {
        this.inputs.forEach(input => { input.value = input.dataset.mixSize === button.dataset.fullSize ? this.dataset.packCount : '0'; });
        this.update();
      }));
      this.form.addEventListener('submit', event => {
        if (!this.update()) { event.preventDefault(); this.form.reportValidity(); this.inputs[0].focus(); }
      });
      this.update();
    }
    update() {
      const expected = Number(this.dataset.packCount);
      const validNumbers = this.inputs.every(input => Number.isInteger(Number(input.value)) && input.value !== '' && Number(input.value) >= 0 && Number(input.value) <= expected);
      const sum = this.inputs.reduce((total, input) => total + Number(input.value || 0), 0);
      const pallets = Number(this.quantity.value);
      const valid = validNumbers && sum === expected && Number.isInteger(pallets) && pallets >= 1;
      this.inputs[0].setCustomValidity(validNumbers && sum === expected ? '' : this.dataset.invalid);
      this.button.disabled = !valid;
      this.status.textContent = this.dataset.status.replace('[count]' , String(sum)).replace('[total]' , String(expected));
      this.status.classList.toggle('is-complete', validNumbers && sum === expected);
      this.querySelector('[data-order-total]').textContent = new Intl.NumberFormat(this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(Number(this.dataset.price) * (Number.isInteger(pallets) && pallets > 0 ? pallets : 1) / 100);
      return valid;
    }
  }
  customElements.define('ol-pallet-mix', PalletMix);
})();
